import React, { Component } from "react";
import { FormGroup, ControlLabel, FormControl, Nav, NavItem, HelpBlock } from "react-bootstrap";
import TitlePage from "../components/TitlePage";
import MenuNavbar from "../components/MenuNavbar";
import { EDTabs } from "../components/EDDOM";
import axios from "axios";
import ConfirmButton from "../components/ConfirmButton";

import "./Integrate.css";

export default class IntegrateSMTP extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isResetting: false,
    };
  }

  resetKey = async () => {
    this.setState({isResetting: true});

    try {
      await axios.post('/api/reset/apikey');

      this.props.reloadUser();
    } finally {
      this.setState({isResetting: false});
    }
  }

  switchView = url => {
    this.props.history.push(url);
  }

  render() {
    var smtphost = window.location.hostname;

    return (
      <MenuNavbar {...this.props}>
        <TitlePage title="SMTP Relay"
          tabs={
            <EDTabs>
              <Nav className="nav-tabs space15" activeKey="2">
                <NavItem eventKey="1" onClick={this.switchView.bind(null, '/integrate')}>Sending API</NavItem>
                <NavItem eventKey="2" disabled>SMTP Relay</NavItem>
                <NavItem eventKey="3" onClick={this.switchView.bind(null, '/integrate/webhooks')}>Event Web Hooks</NavItem>
              </Nav>
            </EDTabs>
          }
        />
        <div className="Login">
          <div className="api-box">
            <h4>You can send transactional messages via SMTP through our SMTP relay.</h4>
            <p>Authenticate using either standard SMTP AUTH login or an <strong>X-Auth-APIKey</strong> header. See the <a href="/api/doc" target="_blank">full documentation</a> for more details.</p>
          </div>
          <form className="space20">
            <FormGroup bsSize="large">
              <ControlLabel>SMTP Host</ControlLabel>
              <FormControl
                value={smtphost}
                readOnly={true}
              />
            </FormGroup>
            <FormGroup bsSize="large">
              <ControlLabel>Port</ControlLabel>
              <FormControl
                value="2525"
                readOnly={true}
              />
            </FormGroup>
            <FormGroup bsSize="large">
              <ControlLabel>API Key</ControlLabel>
              <FormControl
                value={(this.props.user && !this.props.user.admin) ? this.props.user.apikey : ''}
                readOnly={true}
              />
              {(this.props.user && this.props.user.admin) && <HelpBlock>API Keys are per-user and cannot be viewed in the customer data view. Create a user account and log in as that user to view.</HelpBlock>}
            </FormGroup>
            <ConfirmButton
              block
              style={{width: '100%'}}
              disabled={this.state.isResetting || (this.props.user && this.props.user.admin)}
              bsSize="large"
              text="Reset"
              title="Reset API Key"
              prompt="Are you sure you wish to reset your API Key? Any applications using the old key will need to be reconfigured with the new one."
              onConfirm={this.resetKey}
            />
          </form>
          <div className="api-box space20">
            <div className="space20 text-center api-link-box">
              <a target="_blank" href="/api/doc"><h4>View Our Full API Documentation</h4></a>
            </div>
          </div>
        </div>
      </MenuNavbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/IntegrateSMTP.js